import { httpPost } from '../../../../../utils/api.utils';
import { convertUtcToLocalDate, getRequestUserSessionData as getUserData } from '../../../../../utils/helpers.utils';
import { actions } from 'react-redux-form';
import moment from 'moment';

import {
    //model
    wirelessPortOutModel
    //action
    , setSubscriptionDetails
    , setFormSubmitted
    , setFormLoading
    , setResetLoading
} from './../../../../../constants/model-reducers/external/request/wireless-request/wireless-portout.settings';

export const portOutModelAInitialState = wirelessPortOutModel;

const defaultState = () => ({
    isFormLoading: false,
    isResetLoading: false,
    subscription: {},
    circuitDetail: {
        vendorName: "",
        planName: "",
    },
    formSubmitted: false
});

const initialState = defaultState();

export const wirelessPortOutActions = {
    setLoadForm: (isLoad = false) => (dispatch, state) => {
        dispatch({
            type: setFormLoading,
            data: isLoad
        });
    },
    onLoadUpdatePortOut: (subscriptionList, circuitCodePropName) => (dispatch, state) => {
        const { requestData } = state().requestDetail;

        dispatch(actions.reset('wirelessPortOutFormA'));
        
        if (requestData.Circuit.CircuitCode) {
            dispatch(actions.change("wirelessPortOutFormA.circuitCode", requestData.Circuit.CircuitCode));
            dispatch(actions.change('wirelessPortOutFormA.circuitId', requestData.Circuit.CircuitId));
            dispatch(actions.change('wirelessPortOutFormA.terminateDate', !requestData.Order.OrderDisconnectDate === false ? new Date(requestData.Order.OrderDisconnectDate) : ""));
            dispatch(actions.change('wirelessPortOutFormA.businessJustification', requestData.BusinessJustification.BusinessJustification ?? ""));
            dispatch(actions.change('wirelessPortOutFormA.additionalInformation', requestData.BusinessJustification.AdditionalInformation ?? ""));

            var subscription = subscriptionList.find(o => o[circuitCodePropName] === requestData.Circuit.CircuitCode);
            dispatch({ type: setSubscriptionDetails, data: subscription });
        }
        else {
            dispatch(actions.reset('wirelessPortOutFormA'));
            dispatch({ type: setSubscriptionDetails, data: {} });
        }
    },
    onSubscriptionSelect: (value, propsName, objects, index) => (dispatch, state) => {
        const { wirelessPortOutFormA } = state().form;
        const { takeActionCircuitId } = state().createRequest;

        if (value === '' || !propsName) {
            dispatch(actions.reset('wirelessPortOutFormA.circuitCode'));
            dispatch(actions.reset('wirelessPortOutFormA.circuitId'));
            dispatch({ type: setSubscriptionDetails, data: {} });
        } else {
            if(propsName) {
                var obj=null              
                if(objects !== null && objects !== undefined) {
                    if(index !== -1 && index !== undefined && index !== null) {
                        obj=objects[index]
                    }
                    else if(objects.length === 1) {
                        obj=objects.find(o => o[propsName] === value);
                    }
                    else if (objects.length > 1) {
                        obj = objects.find(o => o[propsName] === value & o['CircuitId'] === takeActionCircuitId);
                    } 
                } 
                if (obj != null && parseInt(obj.CircuitId) !== parseInt(wirelessPortOutFormA.circuitId)) {
                    dispatch(actions.change('wirelessPortOutFormA.circuitCode', value));
                    dispatch(actions.change('wirelessPortOutFormA.circuitId', obj.CircuitId));
                    dispatch({ type: setSubscriptionDetails, data: obj });
                }
            }            
        }
    }
    , resetWirelessPortOutForm: (isResetRequestOnBehalf = false) => (dispatch, state) => {

        const { takeActionCircuitCode } = state().createRequest;
        if((takeActionCircuitCode !== '' && takeActionCircuitCode !== undefined && takeActionCircuitCode !== null) && isResetRequestOnBehalf) {
            dispatch({ type: setResetLoading, data: false });
            return;
        }
        if (isResetRequestOnBehalf) {
            dispatch({ type: setResetLoading, data: true });
            dispatch(actions.reset('wirelessPortOutFormA.circuitCode'));
            dispatch(actions.reset('wirelessPortOutFormA.circuitId'));
            dispatch({ type: setSubscriptionDetails, data: {} });

            setTimeout(function () {
                dispatch({ type: setResetLoading, data: false });
            }, 5);
        }
        else if (!isResetRequestOnBehalf) {
            dispatch(actions.reset('wirelessPortOutFormA'));
            dispatch({ type: setSubscriptionDetails, data: {} });
        }
        dispatch(actions.reset('wirelessPortOutFormA'));
        dispatch({ type: setFormSubmitted, data: false });
    }
    , submitRequest: () => async (dispatch, state) => {
        const { wirelessPortOutFormA } = state().form;
        const { requestTypeId, isRequestOnBehalf, requestOnBehalfData, isUpdateRequest } = state().createRequest;
        const { subscription } = state().wirelessPortOutRequest;

        const userData = getUserData();
        if (isRequestOnBehalf) {
            userData.requestInBehalfId = requestOnBehalfData.EmployeeId;
            userData.vip = requestOnBehalfData.Vip;
        }

        userData.managerApproverId = isRequestOnBehalf ?
        requestOnBehalfData.CostCodeApproverEmployeeId : sessionStorage.CostCodeAuthorizerID;

        let changeRequestData = {
            ...userData
            , ...wirelessPortOutFormA
            , VendorDetailId: subscription.VendorDetailId
            , terminateDate: wirelessPortOutFormA.terminateDate ? moment(wirelessPortOutFormA.terminateDate).startOf('day').format('DD MMM YYYY') : null
            , RequestTypeId: requestTypeId
        }

        if (isUpdateRequest) {
            const { requestData } = state().requestDetail;

            changeRequestData = {
                ...changeRequestData,
                OrderId: requestData.Order.OrderId,
                OrderInfoId: requestData.OrderInfoId,
                CircuitOrderId: requestData.CircuitOrderId,
                OrderHistoryId: requestData.OrderHistoryId
            }
        }

        const data = {
            ChangeRequestModel: changeRequestData,
            IsAmending: isUpdateRequest
        };

        dispatch({ type: setFormSubmitted, data: true });

        const res = await httpPost('external/terminateRequest/submitPortOutRequest', data);

        if (!(res.Success)) {
            dispatch({ type: setFormSubmitted, data: false });
        }

        return res;

    }
}

export const reducer = (state, action) => {
    state = state || initialState;

    switch (action.type) {
        case setSubscriptionDetails:
            return {
                ...state
                , subscription: { ...action.data }
            };
        case setFormSubmitted:
            return {
                ...state
                , formSubmitted: action.data
            };
        case setFormLoading:
            return {
                ...state
                , isFormLoading: action.data
            }
        case setResetLoading:
            return {
                ...state
                , isResetLoading: action.data
            }
        default: return state;
    }
}